import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useLanguage } from '../../contexts/LanguageContext';

const { FiAlertTriangle, FiLogOut, FiLoader } = FiIcons;

const LogoutConfirmModal = ({ isOpen, onClose, onConfirm, isLoggingOut }) => {
  const { t, language } = useLanguage();
  
  const fontClass = language === 'zh' ? 'font-semibold tracking-wide' : 'font-medium';

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          transition={{ type: "spring", duration: 0.3 }}
          className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-2xl max-w-md w-full mx-4 border border-gray-200 dark:border-gray-700"
          onClick={(e) => e.stopPropagation()}
        >
          {/* 圖標和標題 */}
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiAlertTriangle} className="h-8 w-8 text-orange-600 dark:text-orange-400" />
            </div>
            <h3 className={`text-xl text-gray-900 dark:text-white mb-2 ${fontClass}`}>
              {t('modals.confirmLogout')}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
              {t('modals.logoutConfirmMessage')}
            </p>
          </div>

          {/* 按鈕區域 */}
          <div className="flex space-x-3">
            <button
              onClick={onClose}
              disabled={isLoggingOut}
              className={`flex-1 px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors ${fontClass} ${
                isLoggingOut ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {t('modals.cancel')}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoggingOut}
              className={`flex-1 px-4 py-3 bg-red-600 hover:bg-red-700 text-white rounded-xl transition-colors flex items-center justify-center space-x-2 ${fontClass} ${
                isLoggingOut ? 'opacity-75 cursor-not-allowed' : ''
              }`}
            >
              {isLoggingOut ? (
                <>
                  <SafeIcon icon={FiLoader} className="h-4 w-4 animate-spin" />
                  <span>{t('modals.loggingOut')}</span>
                </>
              ) : (
                <>
                  <SafeIcon icon={FiLogOut} className="h-4 w-4" />
                  <span>{t('modals.logout')}</span>
                </>
              )}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default LogoutConfirmModal;